import React from 'react';
import axios from '../utils/axiosWithAuth'; // or './utils/axiosWithAuth' based on your file

import { auth } from '../firebase/firebase'; // Adjust the path if needed

export default function SubscribersControl() {
  const handleAddSubscriber = async () => {
    const email = prompt('Enter email to subscribe:');
    if (!email) return;

    try {
      const user = auth.currentUser;
      if (!user) {
        alert('❌ Please log in as admin first.');
        return;
      }

      const token = await user.getIdToken(true); // ✅ Force token refresh
      console.log('👤 Logged in as:', user.email);
      console.log('📨 Email to subscribe:', email);
      console.log('🔐 Token (first 50 chars):', token.slice(0, 50), '...');

      const res = await axios.post(
  `${process.env.REACT_APP_API_URL}/api/save-subscriber`,// ✅ correct API
        { email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(res.data.message || '✅ Subscriber added.');
    } catch (err) {
      console.error('❌ Error adding subscriber:', err?.response?.data || err.message);
      alert(err?.response?.data?.message || '❌ Failed to add subscriber.');
    }
  };

  const handleRemoveSubscriber = async () => {
    const email = prompt('Enter email to unsubscribe:');
    if (!email) return;

    try {
      const user = auth.currentUser;
      if (!user) {
        alert('❌ Please log in as admin first.');
        return;
      }

      const token = await user.getIdToken(); // force refresh here too

      console.log('📨 Email to unsubscribe:', email);
      console.log('🔐 Token (first 50 chars):', token.slice(0, 50), '...');

      const res = await axios.post(
  `${process.env.REACT_APP_API_URL}/api/unsubscribe`,
        { email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(res.data.message || '✅ Subscriber removed.');
    } catch (err) {
      console.error('❌ Error removing subscriber:', err?.response?.data || err.message);
      alert(err?.response?.data?.message || '❌ Failed to remove subscriber.');
    }
  };

  
  return (
  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
    <h3 style={{ marginBottom: '10px' }}>Manage Subscribers</h3>

    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap', // ✅ Wraps buttons on small screens
        gap: '10px', // ✅ Adds consistent spacing
      }}
    >
      <button
        onClick={handleAddSubscriber}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          minWidth: '160px',
        }}
      >
        ➕ Add Subscriber
      </button>

      <button
        onClick={handleRemoveSubscriber}
        style={{
          padding: '10px 20px',
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          minWidth: '160px',
        }}
      >
        ➖ Remove Subscriber
      </button>
    </div>
  </div>
);

}
